import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { orderByGroupStoreCreator, type OrderByGroupStore } from './creator'

export const useOrderByGroupStore = create<OrderByGroupStore>()(
  persist(orderByGroupStoreCreator, {
    name: '@SwileCorporates:Order-by-group',
    storage: createJSONStorage(() => sessionStorage),
    partialize: (state) => {
      return {
        ...state,
        filter: {
          ...state.filter,
          filter: ''
        }
      }
    }
  })
)
